var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9419 3.62617C15.6473 3.02707 14.263 2.59167 12.8157 2.34375C12.638 2.66158 12.4304 3.08906 12.2872 3.42912C10.7487 3.20029 9.22445 3.20029 7.7143 3.42912C7.57116 3.08906 7.3588 2.66158 7.17947 2.34375C5.73067 2.59167 4.3448 3.02867 3.05016 3.62934C0.438869 7.53216 -0.269009 11.338 0.0849305 15.0899C1.81688 16.3691 3.49534 17.1462 5.14548 17.6547C5.55291 17.1001 5.91628 16.5105 6.22931 15.8892C5.63313 15.6651 5.06211 15.3886 4.52256 15.0676C4.6657 14.9627 4.80571 14.8531 4.94098 14.7403C8.23183 16.2626 11.8074 16.2626 15.0589 14.7403C15.1958 14.8531 15.3358 14.9627 15.4774 15.0676C14.9362 15.3902 14.3637 15.6667 13.7675 15.8908C14.0805 16.5105 14.4423 17.1017 14.8513 17.6562C16.503 17.1477 18.1831 16.3707 19.915 15.0899C20.3303 10.7405 19.2056 6.96961 16.9419 3.62617ZM6.67738 12.7838C5.68951 12.7838 4.87936 11.8717 4.87936 10.7609C4.87936 9.65014 5.67221 8.73642 6.67738 8.73642C7.68259 8.73642 8.4927 9.64854 8.4754 10.7609C8.47697 11.8717 7.68259 12.7838 6.67738 12.7838ZM11.5244 10.7609C11.5244 11.8717 12.3345 12.7838 13.3224 12.7838C14.3276 12.7838 15.1204 11.8717 15.1204 10.7609C15.1377 9.64854 14.3276 8.73642 13.3224 8.73642C12.3172 8.73642 11.5244 9.65014 11.5244 10.7609Z",
    fill: "var(--color-neutral-500)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.54a454e4e23a4725cfced21c3f771bad.svg";
export { ForwardRef as ReactComponent };